module.exports = __webpack_public_path__ + "img/画板 3 拷贝.933b9563.png";